import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);

/**
 * В каждой колонке сетки может быть несколько уровней (строк), все их надо обернуть в item
 */
export var AlignedGridItem = function AlignedGridItem(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return React.Children.map(children, function (child, rowIndex) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('item', className),
      key: +rowIndex,
      "data-t-id": "common-AlignedGrid"
    }, child);
  });
};
AlignedGridItem.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string
} : {};